import { capitalize } from 'lodash';
import * as React from 'react';

import { createToast, EditableTextField } from '../';
import { Application, JobSeeker } from '../../../../javascript/models';

interface IProps {
  attribute: string;
  canEdit: boolean;
  canMask?: boolean;
  model: string;
  defaultValue: string;
  id: string;
  isLink?: boolean;
  // Used to determine if we need to fire an event on successful save
  identifier?: string;
  style?: React.CSSProperties;
  refreshApplication?(): Promise<any>;
}

export function EditableTextGraphiti({ attribute, canMask, model, identifier, id, refreshApplication, ...editableTextFieldProps }: IProps) {
  type ModelTypes = JobSeeker | Application;
  const models = {
    Application,
    JobSeeker,
  };

  async function handleSave(value: string) {
    const resource: ModelTypes = new models[model]({ id });
    resource.isPersisted = true;
    resource[attribute] = value;

    const success = await resource.save();
    if (success) {
      if (canMask) {
        refreshApplication()
      }
      createToast({
        // regex to split camelCased words into nicer formatting
        text: `${capitalize(attribute.replace(/([A-Z]+)*([A-Z][a-z])/g, '$1 $2'))} was successfully updated`,
        type: 'success',
      });
      if (identifier) {
        const customEvent = new CustomEvent(identifier);
        document.dispatchEvent(customEvent);
      }
    } else {
      createToast({
        text: Object.keys(resource.errors)
          .map((key) => resource.errors[key].fullMessage)
          .join(', '),
        type: 'error',
      });
    }
    return success;
  }

  return <EditableTextField {...editableTextFieldProps} {...{ canMask, handleSave }} name={attribute} />;
}

export default EditableTextGraphiti;
